import { useState, useEffect } from "react";
import { getUserInfo, updateUserImage, updateUser } from "../../../../services/userService";
import { UserBase } from "../../../../types/userTypes";


const useProfile = () => {
  const [profile, setProfile] = useState<UserBase | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingUpdateImage, setIsLoadingUpdateImage] = useState(false);
  const [isLoadingUpdateUser, setIsLoadingUpdateUser] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const getInfoUser = async () => {
    try {
      setIsLoading(true);
      setError(null);
      const userData = await getUserInfo();
      console.log(userData);
      setProfile(userData);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Failed to fetch user info");
    } finally {
      setIsLoading(false);
    }
  };

  const updateImageProfile = async (imageFile: File | null) => {
    try {
      setIsLoadingUpdateImage(true);
      setError(null);
      const updatedProfile = await updateUserImage(imageFile);
       setProfile(prev => prev ? { ...prev, photo: updatedProfile.photo } : null);
      return true;
    } catch (err) {
      setError(err instanceof Error ? err.message : "Failed to update profile image");
      return false;
    } finally {
      setIsLoadingUpdateImage(false);
    }
  };

  const updateUserProfile = async (updatedData: Partial<UserBase>) => {
    try {
      setIsLoadingUpdateUser(true);
      setError(null);
      const updatedProfile = await updateUser(updatedData);
      setProfile(prev => prev ? { ...prev, ...updatedProfile } : null);
      return true;
    } catch (err) {
      setError(err instanceof Error ? err.message : "Failed to update profile");
      return false;
    } finally {
      setIsLoadingUpdateUser(false);
    }
  };

  useEffect(() => {
    getInfoUser();
  }, []);

  return {
    profile,
    isLoading,
    error,
    getInfoUser,
    updateImageProfile,
    updateUserProfile,
    isLoadingUpdateImage,
    isLoadingUpdateUser
  };
};

export default useProfile;
